/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { AI_METADATA_BATCH } from './ai-metadata-batches.strings'
import { AI_METADATA } from './ai-metadata.strings'
import { BACK_TO } from './general'

export const LICENSED_ASSET_TITLE = 'Your Licensed Assets'
export const AI_METADATA_BUILT_TITLE = `${AI_METADATA} built`
export const BACK_TO_LICENSED_ASSET_LABEL = `${BACK_TO} ${LICENSED_ASSET_TITLE}`
export const BUILD_AI_METADATA = `Build ${AI_METADATA}`
export const BUILD_AI_METADATA_BATCH_LABEL = `Build ${AI_METADATA_BATCH}`
export const EXPORT_LICENSED_ASSETS_LABEL = 'Export Licensed Assets'
export const SHOW_ASSET_METADATA = 'Show Asset Metadata'
export const ACCEPT_TERMS_LABEL = `Accept Terms + ${BUILD_AI_METADATA}`
